import { detectMobileOperatingSystem } from '../../utils/browser'

export function useMobileOS() {
  return detectMobileOperatingSystem()
}
